import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";

const PageView = ({
    title,
    children,
    closeTo = "/",
    columns = 1,
    showButton = false,
    buttonLabel = "Edit",
    onButtonClick = () => { }
}) => {
    const navigate = useNavigate();

    const colsMap = {
        1: "grid-cols-1",
        2: "grid-cols-2",
        3: "grid-cols-3",
        4: "grid-cols-4",
    };

    return (
        <div className="w-full p-4 bg-white mt-5 rounded-lg shadow-xl relative">
            <div className="flex items-center justify-between border-b pb-2 mb-4">
                <h1 className="text-lg font-semibold text-gray-800">{title}</h1>
                <button
                    onClick={() => navigate(closeTo)}
                    className="p-2 rounded-full hover:bg-gray-200 transition"
                >
                    <X size={20} />
                </button>
            </div>

            <div className={`grid gap-4 ${colsMap[columns] || "grid-cols-1"}`}>
                {children}
            </div>

            {showButton && (
                <div className="flex justify-end mt-4">
                    <button
                        onClick={onButtonClick}
                        className="px-4 py-2 bg-[#e98841] text-white rounded-lg shadow-md  transition"
                    >
                        {buttonLabel}
                    </button>
                </div>
            )}
        </div>
    );
};

export default PageView;
